
import { BASE_END_POINT } from "../../parametros";
import i18n from 'i18next';
import { MercadoPago_Produtos_ParametrizadosDTO } from "../dtos/MercadoPago_Produtos_ParametrizadosDTO";

async function buscarProdutosParametrizados(): Promise<MercadoPago_Produtos_ParametrizadosDTO[]> {

    const url = `${BASE_END_POINT}/api-v1/pagamentos/produtos-parametrizados`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar produtos parametrizados. Código: ${response.status}`);
    }

    return await response.json() as MercadoPago_Produtos_ParametrizadosDTO[];
}

export {
    buscarProdutosParametrizados
};
